export default __webpack_public_path__ + "static/media/caligolite-seal.0eae5334.svg";